class Reveal {
  constructor() {

    this.stickySections = [...document.querySelectorAll('.js-sticky')];
    this.revealSections = [...document.querySelectorAll('.js-reveal')];

    this.bannerSection = document.querySelector('.js-banner');
    this.bannerTitleSection = document.querySelectorAll('.js-banner-title');

    this.progressSection = document.querySelector('.lc-start-progress__track');

    this.strategyMenuItems = [...document.querySelectorAll('.lc-start-strategy__tab-menu-item')];
    this.strategyItems = [...document.querySelectorAll('.lc-start-strategy__tab-item')];

    if(this.stickySections.length > 0) {
      this.bindSticky();
    }

    if(this.revealSections.length > 0) {
      this.bindReveal();

      window.addEventListener("scroll", () => {
        this.bindReveal();
      });
    }

    if(this.bannerSection) {
      this.bannerSectionOffsetTop = this.bannerSection.getBoundingClientRect().top;
      this.bindBanner();
    }

    if(this.bannerTitleSection.length > 0){
      this.bannerTitleSectionOffsetTop = this.bannerTitleSection[0].getBoundingClientRect().top;
      this.bindBannerTitle();
    }

    if(this.progressSection) {
      this.bindProgress();
    }

    if(this.strategyMenuItems.length > 0 && this.strategyItems.length > 0) {
      this.bindStrategyItems();
      this.bindStrategySlider();
    }
  }

  bindReveal() {
    for (let i = 0; i < this.revealSections.length; i++) {
      let windowHeight = window.innerHeight;
      let elementTop = this.revealSections[i].getBoundingClientRect().top;
      let elementVisible = 400;

      if (elementTop < windowHeight - elementVisible) {
        this.revealSections[i].classList.add("lc-reveal--active");
      }
    }
  }

  bindSticky() {
    window.addEventListener("scroll", () => {
      for(let i = 0; i < this.stickySections.length; i++) {
        this.transformSticky(this.stickySections[i]);
      }
    });
  }

  transformSticky(section) {
    const scrollSection = section.querySelector('.lc-startpage-slider-projects__content');
    const textElement = section.querySelector('.lc-startpage-container__text');
    if (!scrollSection || !textElement) return;

    const sectionTop = section.offsetTop;
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;

    const textPadding = parseInt(window.getComputedStyle(textElement).paddingLeft);

    const items = scrollSection.querySelectorAll('.lc-startpage-item-project');
    const itemWidth = items[0]?.offsetWidth || 0;
    const gap = 7;
    const totalWidth = (itemWidth + gap) * items.length;
    const containerWidth = Math.max(totalWidth + (textPadding * 2), 2000);

    scrollSection.style.width = `${containerWidth}px`;

    if (scrollY >= sectionTop - (viewportHeight * 0.01)) {
      const viewportWidth = document.body.clientWidth;
      const maxScroll = section.offsetHeight - viewportHeight;
      const currentScroll = Math.min(Math.max(scrollY - (sectionTop - (viewportHeight * 0.01)), 0), maxScroll);
      const scrollProgress = currentScroll / maxScroll;

      let percentage;
      if (document.body.clientWidth >= 1104) {
        const maxScrollPercentage = ((containerWidth - viewportWidth) / containerWidth) * 100;
        percentage = scrollProgress * maxScrollPercentage;
      } else {
        const targetPercentage = ((containerWidth - viewportWidth) / containerWidth * 100);
        percentage = scrollProgress * targetPercentage;
      }

      scrollSection.style.transform = `translate3d(calc(-${percentage}% + ${textPadding}px), 0, 0)`;
    } else {
      scrollSection.style.transform = `translate3d(${textPadding}px, 0, 0)`;
    }
  }

  bindBanner() {
    let bannerBefore = this.bannerSection.cloneNode(true)
    bannerBefore.classList.add('lc-start-strategy__banner--before');
    bannerBefore.style.marginLeft = "-" + this.bannerSection.clientWidth - 100 + "px"

    let bannerBefore2 = this.bannerSection.cloneNode(true)
    bannerBefore2.classList.add('lc-start-strategy__banner--before');
    bannerBefore2.style.marginLeft = "-" + this.bannerSection.clientWidth - 100 - this.bannerSection.clientWidth - 100 + "px"

    let bannerAfter = this.bannerSection.cloneNode(true)
    bannerAfter.classList.add('lc-start-strategy__banner--after');
    bannerAfter.style.marginLeft = this.bannerSection.clientWidth + 100 + "px"

    let bannerAfter2 = this.bannerSection.cloneNode(true)
    bannerAfter2.classList.add('lc-start-strategy__banner--after');
    bannerAfter2.style.marginLeft = this.bannerSection.clientWidth + 100 + this.bannerSection.clientWidth + 100 + "px"

    this.bannerSection.insertAdjacentElement('beforebegin', bannerBefore);
    this.bannerSection.insertAdjacentElement('afterend', bannerAfter);
    this.bannerSection.insertAdjacentElement('beforebegin', bannerBefore2);
    this.bannerSection.insertAdjacentElement('afterend', bannerAfter2);

    window.addEventListener("scroll", () => {
      this.transformBanner(this.bannerSection);
      this.transformBanner(bannerBefore);
      this.transformBanner(bannerAfter);
      this.transformBanner(bannerBefore2);
      this.transformBanner(bannerAfter2);
    });
  }

  bindBannerTitle() {
    this.bannerTitleSection.forEach(banner => {
      let bannerBefore = banner.querySelector('h1').cloneNode(true);
      bannerBefore.classList.add('lc-banner-title__banner--before');
      bannerBefore.style.marginLeft = "-" + banner.querySelector('h1').clientWidth - 100 + "px"

      let bannerBefore2 = banner.querySelector('h1').cloneNode(true);
      bannerBefore2.classList.add('lc-banner-title__banner--before');
      bannerBefore2.style.marginLeft = "-" + banner.querySelector('h1').clientWidth - 100 - banner.querySelector('h1').clientWidth - 100 + "px"

      let bannerAfter = banner.querySelector('h1').cloneNode(true);
      bannerAfter.classList.add('lc-banner-title__banner--after');
      bannerAfter.style.marginLeft = banner.querySelector('h1').clientWidth + 100 + "px"

      let bannerAfter2 = banner.querySelector('h1').cloneNode(true);
      bannerAfter2.classList.add('lc-banner-title__banner--after');
      bannerAfter2.style.marginLeft = banner.querySelector('h1').clientWidth + 100 + banner.querySelector('h1').clientWidth + 100 + "px"

      let bannerAfter3 = banner.querySelector('h1').cloneNode(true);
      bannerAfter3.classList.add('lc-banner-title__banner--after');
      bannerAfter3.style.marginLeft = banner.querySelector('h1').clientWidth + 100 + banner.querySelector('h1').clientWidth + 100 + banner.querySelector('h1').clientWidth + 100 + "px"

      banner.insertAdjacentElement('afterbegin', bannerBefore);
      banner.insertAdjacentElement('afterbegin', bannerAfter);
      banner.insertAdjacentElement('afterbegin', bannerBefore2);
      banner.insertAdjacentElement('afterbegin', bannerAfter2);
      banner.insertAdjacentElement('afterbegin', bannerAfter3);

      window.addEventListener("scroll", () => {
        this.transformBannerTitle(banner);
      });
    });
  }

  transformBanner(section) {
    let percentage = ((window.scrollY - this.bannerSectionOffsetTop + window.innerHeight/1.5) / window.innerHeight) * 125;
    section.style.transform = `translate3d(${-(percentage)}%, 0, 0)`;
  }

  transformBannerTitle(section) {
    if(section != null) {
      let number = 10;
      if(section.getAttribute('data-title') == 2) {
        number = -30;
      } else if(section.getAttribute('data-title') == 3) {
        number = 40;
      }

      if(window.innerWidth < 768) {
        number = 100;
      if(section.getAttribute('data-title') == 2) {
        number = -70;
      } else if(section.getAttribute('data-title') == 3) {
        number = 80;
      }
      }

      let percentage = ((window.scrollY - this.bannerTitleSectionOffsetTop + window.innerHeight/1.5) / window.innerHeight) * number;
      section.style.transform = `translate3d(${-(percentage)}%, 0, 0)`;
    }
  }

  bindProgress() {
    let svg = document.querySelector('svg.lc-start-progress__line--active');
    let path = svg.querySelector('path');

    if(window.innerWidth < 1280) {
      svg = document.querySelector('.lc-start-progress__svg--mobile svg.lc-start-progress__line--active');
      path = svg.querySelector('path');
    }

    const scroll = () => {
      const offsetTop = this.progressSection.getBoundingClientRect().top + window.scrollY;
      const distance = window.scrollY - offsetTop + window.innerHeight/2 + window.innerHeight/4;
      const totalDistance = svg.clientHeight;
      const percentage = distance / totalDistance;
      const pathLength = path.getTotalLength();

      path.style.strokeDasharray = `${pathLength}`;
      if(svg.closest('.lc-start-progress__svg--mobile')){
        path.style.strokeDashoffset = `${pathLength * (1 + percentage)}`;
      } else if(svg.closest('.lc-progress-extended')){
        path.style.strokeDashoffset = `${pathLength * (1 - percentage)}`;
      } else {
        path.style.strokeDashoffset = `${pathLength * (1 + percentage)}`;
      }
    }

    scroll();
    window.addEventListener('scroll', scroll);
  }

  bindStrategyItems() {
    this.strategyItems.forEach((item, index) => {
      let indexUp = index + 1;
      item.classList.add('lc-start-strategy__tab-item--' + indexUp);
      if(index == 0) {
        item.classList.add('lc-start-strategy__tab-item--active');
      }
    });
  }

  bindStrategySlider() {
    this.strategyMenuItems.forEach(item => {
      item.addEventListener("click", () => {
        document.querySelectorAll('.lc-start-strategy__tab-item').forEach(tabItem => {
          tabItem.classList.remove('lc-start-strategy__tab-item--active');
          tabItem.style = "";
        });
        document.querySelectorAll('.lc-start-strategy__tab-menu-item').forEach(tabItem => {
          tabItem.classList.remove('lc-start-strategy__tab-menu-item--active');
        });
        document.querySelector('.lc-start-strategy__tab-menu-item--' + item.getAttribute('data-item')).classList.add('lc-start-strategy__tab-menu-item--active');
        document.querySelector('.lc-start-strategy__tab-item--' + item.getAttribute('data-item')).classList.add('lc-start-strategy__tab-item--active');
        document.querySelector('.lc-start-strategy__tab-item--' + item.getAttribute('data-item')).style.opacity = 0;
        document.querySelector('.lc-start-strategy__tab-item--' + item.getAttribute('data-item')).style.transition = "opacity .4s ease-in-out";
        setTimeout(() => {
          document.querySelector('.lc-start-strategy__tab-item--' + item.getAttribute('data-item')).style.opacity = 1;
        },1);
      });
    });
  }
}

export default Reveal;
